import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import {
  resetBase64Labo,
  wsGetMisLaboratoriosSimplify,
  wsGetResultadoLaboratorio,
} from "../../context/Actions/misLaboratorios/misLaboratorios";
import "./MisLaboratorios.css";
import CardLaboratorio from "../../components/Perfil/CardLaboratorio/CardLaboratorio";
import { laboratorioTituloTxt } from "./MisLaboratoriosTituloTxt";
import Dropdown from "../../components/Genericos/Dropdown/Dropdown";
import MultitabMobileMisLaboratorios from "../../components/Turnos/MultitabMobileMisLaboratorios/MultitabMobileMisLaboratorios";
import Loading from "../../components/Genericos/Loading/Loading";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { dropdownFamiliares } from "../../components/Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import { showModal } from "../../context/Actions/modal/modal";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import {
  LimpiarSelectGlobal,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../global/context/Provider";
import { detectarNavegador } from "global/utils/detectarNavegador";
import { detectarIOS } from "global/utils/detectarIOS";
import { hideModal } from "global/context/action/modal/modal";
import { loginTokenReset } from "_+_Portal/context/Actions/token/loginToken";
import { showToaster } from "global/context/action/toaster/toaster";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { motion } from "framer-motion";
import {
  container,
  dots,
  pageContainerVariants,
} from "global/utils/cardAnimation";
import SelectDropdown from "_+_Portal/components/Genericos/SelectDropdown/SelectDropdown";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const MisLaboratorios = () => {
  const {
    misLaboratoriosState,
    misLaboratoriosDispatch,
    ayudaDispatch,
    listaFamiliaresState,
    modalDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    enviarMailState,
    textosState,
    tokenState,
    tokenDispatch,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  const history = useHistory();
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [flgBtnFiltro, setFlgBtnFiltro] = useState(true);
  const [laboData, setLaboData] = useState(null);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onClickBuscarTurnos = () => {
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/consultamedica");
    }
  };
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onChangeMultitabLaboratorio = (e) => {
    // hacer el dispatch aqui
    if (e !== "") {
      if (e.familiar && e.verResultados) {
        wsGetMisLaboratoriosSimplify(
          e.id,
          true,
          cargarEstudios,
        )(misLaboratoriosDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        setFlgBtnFiltro(true);
      } else if (!e.familiar) {
        wsGetMisLaboratoriosSimplify(
          -1,
          true,
          cargarEstudios,
        )(misLaboratoriosDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      } else {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro",
        )(modalDispatch);
        wsGetMisLaboratoriosSimplify(
          -1,
          true,
          cargarEstudios,
        )(misLaboratoriosDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      }
    
    }
  };

  const traerEstudios = () => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisLaboratoriosSimplify(
        -1,
        false,
        cargarEstudios,
      )(misLaboratoriosDispatch);
      setFlgBtnFiltro(false);
    } else {
      wsGetMisLaboratoriosSimplify(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        false,
        cargarEstudios,
      )(misLaboratoriosDispatch);
      setFlgBtnFiltro(false);
    }
  };

  useEffect(() => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisLaboratoriosSimplify(
        -1,
        true,
        cargarEstudios,
      )(misLaboratoriosDispatch);
    } else {
      wsGetMisLaboratoriosSimplify(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        true,
        cargarEstudios,
      )(misLaboratoriosDispatch);
    }
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }, 250);
  }, []);

  // useEffect(() => {
  //   if (misLaboratoriosState.misLaboratorios.data !== null) {
  //     buscarInformePorNotificacion();
  //   }
  // }, [misLaboratoriosState.misLaboratorios.data]);

  const buscarInformePorNotificacion = () => {
    if (tokenState.token.data !== null) {
      const idProtocolo = tokenState.token.data.idprotocolo;
      const listInformes = misLaboratoriosState.misLaboratorios.data;

      const informeEncontrado = listInformes?.find(
        (informe) => informe.codigo === idProtocolo,
      );
      if (informeEncontrado) {
        modalInformePdf(informeEncontrado?.codigo);
      }
    }
  };

  const modalInformePdf = (idProtocolo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        informePdf(idProtocolo);
      } else {
        modalAvisoNavegador();
      }
    } else {
      informePdf(idProtocolo);
    }
  };

  const informePdf = (idProtocolo) => {
    wsGetResultadoLaboratorio(idProtocolo, verPDF)(misLaboratoriosDispatch);
  };

  const verPDF = (isCorrect, data) => {
    if (isCorrect) {
      showModal(
        "Genericos/InformePDF/InformePDFLabo",
        {
          titulo: `Informe de Laboratorio`,
          dissmiss: dissmiss,
          blob: data?.blob,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: "En este momento no se puede ver/descargar el informe",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };

  const modalAvisoNavegador = () => {
    showModal(
      "Genericos/DeteccionNavegador/DeteccionNavegador",
      {},
      [],
      "centro",
      false,
    )(modalDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
    resetBase64Labo()(misLaboratoriosDispatch);
    loginTokenReset()(tokenDispatch);
  };

  const cargarEstudios = (isCorrect, data) => {
    if (isCorrect) {
      setLaboData(data);
    } else {
      showToaster(
        {
          texto: data ? data : "Error al cargar estudios",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  return (
    <React.Fragment>
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={
          misLaboratoriosState.misLaboratorios.loading ||
          enviarMailState.enviarMail.loading
        }
        color="c-white"
        descripcion={
          misLaboratoriosState.misLaboratorios.loading
            ? "Cargando Estudio..."
            : "Enviando informe..."
        }
      />
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Mis Laboratorios"} />
      <MultitabMobileMisLaboratorios
        valor={
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
            : authState.auth.data.paciente.codigo
        }
        datos={dropdownFamiliares(
          listaFamiliaresState,
          authState,
          "VerResultados",
        )}
        onChange={onChangeMultitabLaboratorio}
      />
      <div className="ptur-bodyContainer-misLaboratorios">
        <div className="ptur-mainSidebar">
          <Sidebar />
        </div>

        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"mismed-body-misLaboratorios"}
        >
          <div className="ptur-misLaboratorios-tituloLabo rb24b">
            {laboratorioTituloTxt}
            <div className="ptur-misLaboratorios-dropdown-boton-container">
              <div className="ptur-misLaboratorios-dropdown">
                <SelectDropdown
                  data={dropdownFamiliares(
                    listaFamiliaresState,
                    authState,
                    "VerResultados",
                  )}
                  descripcion={"nombre"}
                  placeholder={"Seleccionar Familiar"}
                  onChangeInput={onChangeMultitabLaboratorio}
                  selectedValue={
                    selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                      ? selectDropDownState.selectDropDown.selectGlobal
                          .pacienteElegido.paciente
                      : authState.auth.data.paciente
                  }
                />
              </div>
            </div>
            <hr className="ptur-misLaboratorios-lineaSeparadora" />
          </div>
          {/*           {flgBtnFiltro ? (
            <div className="ptur-misLaboratorios-filtro bgc-latex10 c-white rb18l">
              <p>Se están mostrando los estudios de los últimos 3 meses</p>
              <button
                className="ptur-misLaboratorios-filtroBtn bgc-latex10 c-white rb18l"
                onClick={traerEstudios}
              >
                Ver Todos
              </button>
            </div>
          ) : (
            ""
          )} */}
          <div className="ptur-misLaboratorios-noEcontrado">
            <TurnoNoEncontrado
              state={misLaboratoriosState.misLaboratorios?.data}
              loadingState={misLaboratoriosState.misLaboratorios}
              texto={textosState.textos.data?.ofrecerBusqueda?.nombre}
              recomendacion={
                textosState.textos.data?.ofrecerBusqueda?.descripcion
              }
              txtBtn="Buscar un turno"
              onClickTurnos={onClickBuscarTurnos}
              showBtn={true}
            />
          </div>

          <motion.ul
            key={laboData?.length}
            className="ptur-misLaboratorios-cards"
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
          >
            {Array.isArray(laboData) &&
              laboData
                .filter((item) => {
                  if (item.validado === false && item.validaparcial === false) {
                    const dias = (new Date() - new Date(item.fechaentrega)) / 86400000;
                    return dias <= 180;
                  }
                  return true;
                })
                .map((item, index) => (
                <motion.li
                  key={index}
                  className="itemCardLabo"
                  variants={dots()}
                >
                  <div className="ptur-misLaboratorios-body">
                    <CardLaboratorio item={item} />
                  </div>
                </motion.li>
              ))}
          </motion.ul>
          {misLaboratoriosState.misLaboratorios.loading &&
          laboData?.length > 0 ? (
            ""
          ) : (
            // <div className="ptur-misLaboratorios-botonSubir">
            //   <BotonSubir body={"mismed-body-misLaboratorios"} />
            // </div>
            <FloatingScroll body={"mismed-body-misLaboratorios"} />
          )}
        </motion.div>
      </div>
    </React.Fragment>
  );
};
export default MisLaboratorios;
